import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../_metronic/helpers'
import {getGroups, getFranchises, getUsersById} from './_resquest'
import {Option} from 'react-multi-select-component'
import {TFranchiseResponse} from '../../../coreGlobal/models/franchise/franchise'
import {IUserResponse} from '../../../coreGlobal/models/user'
interface IFormContext {
  // Painel admin: usa as rotas /admin, CPF/telefone opcionais e senha sem regras de complexidade
  isAdmin: boolean
  basePath: string

  user: IUserResponse | undefined
  setUser: React.Dispatch<React.SetStateAction<IUserResponse | undefined>>
  getDataUser: (id: string) => Promise<any>

  group: Option[]
  setGroup: React.Dispatch<React.SetStateAction<Option[]>>

  groups: Option[]
  setGroups: React.Dispatch<React.SetStateAction<Option[]>>
  getDataGroups: () => void

  franchises: Option[]
  setFranchises: React.Dispatch<React.SetStateAction<Option[]>>
  getDataFranchises: () => void

  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const FormContext = createContext<IFormContext>({} as IFormContext)

type Props = WithChildren & {isAdmin?: boolean}

const UsersFormProvider: FC<Props> = ({children, isAdmin = false}) => {
  const basePath = isAdmin ? '/admin/users' : '/users/list'
  const [user, setUser] = useState<IUserResponse>()
  const [group, setGroup] = useState<Option[]>([])
  const [groups, setGroups] = useState<Option[]>([])
  const [franchises, setFranchises] = useState<Option[]>([])
  const [loading, setLoading] = useState(false)

  const getDataUser = async (id: string) => {
    const data = await getUsersById(id, isAdmin)
    setUser(data)
    return data
  }

  const getDataGroups = async () => {
    const data = await getGroups(isAdmin)
    setGroups(data)
  }

  const getDataFranchises = async () => {
    const data = await getFranchises(isAdmin)
    const value = data?.map((franchise: TFranchiseResponse): Option => {
      return {
        label: String(franchise?.name),
        value: Number(franchise?.id as number),
      }
    })
    setFranchises(value)
  }

  return (
    <FormContext.Provider
      value={{
        isAdmin,
        basePath,
        user,
        setUser,
        getDataUser,
        group,
        setGroup,
        groups,
        setGroups,
        getDataGroups,
        franchises,
        setFranchises,
        getDataFranchises,
        loading,
        setLoading,
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

const UsersForm = () => useContext(FormContext)

export {UsersFormProvider, UsersForm}
